import { render, staticRenderFns } from "./row-page-provider.vue?vue&type=template&id=cff4a192"
import script from "./row-page-provider.vue?vue&type=script&lang=js"
export * from "./row-page-provider.vue?vue&type=script&lang=js"
import style0 from "./row-page-provider.vue?vue&type=style&index=0&id=cff4a192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports